import { PAGE_VIEW_PROJECTS } from '@/config/page-view-projects';

export interface PageViewRow {
  hostname: string;
  kind: 'bucket' | 'route' | 'total';
  bucket: string | null;
  route: string | null;
  views: number;
  sessions: number;
  session_views: number;
  bot_views: number;
}
export interface PageViewResponse {
  start: string;
  end: string;
  interval: string;
  rows: PageViewRow[];
}
export const projectName = (hostname: string) =>
  Object.prototype.hasOwnProperty.call(PAGE_VIEW_PROJECTS, hostname)
    ? PAGE_VIEW_PROJECTS[hostname]
    : hostname;
export const chartPoints = (
  data: PageViewResponse,
  projects: string[],
  metric: 'views' | 'sessions'
) => {
  const step = data.interval === 'hour' ? 3600000 : 86400000;
  const start = Math.floor(Date.parse(data.start) / step) * step;
  const buckets = new Map<number, Record<string, number>>();
  for (let time = start; time < Date.parse(data.end); time += step)
    buckets.set(time, Object.create(null));
  data.rows
    .filter((row) => row.kind === 'bucket')
    .forEach((row) => {
      const point = buckets.get(Date.parse(row.bucket!));
      const project = projectName(row.hostname);
      if (point) point[project] = (point[project] || 0) + row[metric];
    });
  return Array.from(buckets).map(([time, values]) => ({
    time,
    values: projects.map((name) => values[name] || 0),
  }));
};
